import {
  foundationPropPredicate,
  getFoundationProps,
  makeFoundationPerimeters,
  makeFoundationPropLinework,
} from "building-generation/utils/foundation";
import { makePropLocations } from "building-generation/utils/propDimensions";
import { SheetGeometryCategory } from "building-types/views/sheetGeometryCategory";
import { sheetPolylineGeometryNew } from "building-types/views/sheetGeometryTypes";
import type { PlanGenerationContext } from "doc/plans/planGeometrySource";
import { PlanGeometryBuilder } from "doc/plans/planGeometrySource";
import type { PlanGeometryGeneratorResult } from "doc/plans/planGeometrySourceTypes";
import { makeReportingUnitFoundationOutlineFilter } from "./entities/planFoundations";

export async function makePlanGeometryFromFoundationPropLinework({
  building,
  levelId,
  selectedReportingUnitLabelId,
}: PlanGenerationContext): Promise<PlanGeometryGeneratorResult> {
  const foundationProps = getFoundationProps(building, foundationPropPredicate(building, levelId));
  const { exteriorPerimeters } = makeFoundationPerimeters(building, levelId);
  const propLocations = await makePropLocations(building, foundationProps, exteriorPerimeters);
  const { dashedLinework, linework } = makeFoundationPropLinework(propLocations);

  const outlineFilter = makeReportingUnitFoundationOutlineFilter(building, levelId, selectedReportingUnitLabelId);

  const builder = new PlanGeometryBuilder();

  builder.addGeometry(
    sheetPolylineGeometryNew({
      handle: building.levels[levelId].handle,
      paths: outlineFilter(dashedLinework),
    }),
    SheetGeometryCategory.FOUNDATION_DASHED_LINEWORK,
  );

  builder.addGeometry(
    sheetPolylineGeometryNew({
      handle: building.levels[levelId].handle,
      paths: outlineFilter(linework),
    }),
    SheetGeometryCategory.FOUNDATION_SOLID_LINEWORK,
  );

  return builder;
}
